import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import * as _ from 'lodash';

import { ProjectModel } from '../../../services/project.model.service';
import { UserRest } from '../../../services/core.user.rest.service';
import { GfTitleService } from '../../../services/core.title.service';
import { ProjectRegistrationHelper } from './project.registration.helper';

@Component({
    selector: 'project-registration',
    template: require('./project.registration.html'),
})
export class ProjectRegistrationComponent implements OnInit {

    @Input() user: any = null;
    @Input() project: any = null;
    @Input() projectMenu: any = null;
    @Input() siteConfig: any = null;

    projectForm: UntypedFormGroup;

    isProjectRegistration = true;
    isOrgRegistration = false;

    constructor(
        private projectModel: ProjectModel,
        protected projectRegistrationHelper: ProjectRegistrationHelper,
        private $window: Window,
        private userRest: UserRest,
        private titleService: GfTitleService,
    ) { }

    ngOnInit() {
        this.titleService.setTitle('Register a project');

        const defaults = {
            isOrgRegistration: false,
            allowTemplateSelect: _.get(this.siteConfig, 'allowTemplateSelect', 0),
            templateProjectId: _.get(this.siteConfig, 'defaultTemplateProject', 0),
            parentProject: this.project,
            parentProjectId: this.project?.id,
            isTemplate: "N",
            isPublic: "N",
            requireCaptcha: Number(_.get(this.siteConfig, 'requireProjectCaptcha', 0)),
        };

        this.projectForm = this.projectRegistrationHelper.getRegistrationForm(defaults);

        if (_.isEmpty(this.project)) {
            //Load Orgs
            this.userRest.getProjects(this.user.unixName, { isOrg: true })
                .then((ret) => {
                    const orgs = _.get(ret, 'items', []);

                    // If there's only one org, preselect it
                    if (orgs.length == 1) {
                        this.projectForm.patchValue({
                            parentProject: orgs[0],
                            parentProjectId: orgs[0].id,
                        });
                    }
                    // No longer needed, as org-selector loads its own data.
                    this.projectRegistrationHelper.showOrgs = (orgs.length > 0);
                });
        }

        this.projectModel.getAvailableScmModules().then(
            (data) => {
                // [#52381] - Don't offer CVS for new projects
                this.projectRegistrationHelper.availableScmModules = _.filter(
                    _.get(data, 'items', []),
                    (module) => module != 'scmcvs'
                );
            }
        );

        this.projectRegistrationHelper.savingProject = false;
        this.projectRegistrationHelper.captchaRefresh = 0;
        this.projectRegistrationHelper.activeTab = 'Project';
    };
}
